// extracted by mini-css-extract-plugin
module.exports = {"actionButtons":"SingleClassPurchaseFlow_actionButtons__N7Iml","single":"SingleClassPurchaseFlow_single__LaFTu","monthly":"SingleClassPurchaseFlow_monthly__5ov7I"};